/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsPlatformProviderLight {
    getFixupPrototypeFunction() { return FilterOptionsPlatformProviderLight.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsPlatformProviderLight>): FilterOptionsPlatformProviderLight {
        let obj = Object.assign(new FilterOptionsPlatformProviderLight(), model);
        FilterOptionsPlatformProviderLight.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsPlatformProviderLight>): FilterOptionsPlatformProviderLight {
        if (!model) return null;
        return FilterOptionsPlatformProviderLight.newInstance(<FilterOptionsPlatformProviderLight> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsPlatformProviderLight) {
        if (!obj) return;

        models.FilterOptionsPlatformProviderLight.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsPlatformProviderLight): boolean {
        Object.setPrototypeOf(obj, FilterOptionsPlatformProviderLight.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Platform for the accounts
     */
    platform: models.ResourceName;

    /**
     * Currencies
     */
    currencies: Array<models.Currency>;

}
